import React, {useState,useEffect} from "react";
import Pagination from "react-pagination-js";
import "react-pagination-js/dist/styles.css";
import { Store } from "../Utility/Store";
import { fetchPOCAggs, fetchPOCData, set_start_page } from "../Utility/actions";

export default function ResultPagination() {
  const { state, dispatch } = React.useContext(Store);
  const [currentPage, setCurrentPage] = useState(state.start_page);

  useEffect(()=>{
    setCurrentPage(state.start_page)
  },[state.start_page])

  let changeCurrentPage = (numPage) => {
    setCurrentPage(numPage);
    set_start_page(dispatch,numPage)
    let obj = {
        query: state.query,
        program: state.program,
        center_hub: state.center,
        institutions: state.institutions,
        technology: state.technology,
        technology_subtype: state.technology_subtype,
        disease: state.disease,
        target: state.target,
        licensing: state.licensing,
        status: state.status,
        size : state.per_page,
        offset : ((numPage-1)*state.per_page)
      };
      fetchPOCData(dispatch,obj)
  };

  return (
    <React.Fragment>
      {state.results.total ? (
        state.results.total.value > state.per_page ? (
          <Pagination
            currentPage={currentPage}
            totalSize={state.results.total.value-1}
            sizePerPage={state.per_page}
            changeCurrentPage={changeCurrentPage}
            theme="bootstrap"
          />
        ) : (
          ""
        )
      ) : (
        ""
      )}
    </React.Fragment>
  );
}
